import React, { Component } from "react";
import { Modal, Header, Button, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";

@observer
class ModalDeletePage extends Component {
  render() {
    const { closeModal, confirmDelete, deleteConfirmation, t } = this.props;

    return (
      <Modal open={deleteConfirmation}>
        <Header icon="exclamation circle" content={t("customerPortal:deletePage")} />
        <Modal.Content>
          <p>{t("customerPortal:deleteMessage")}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button color="green" onClick={() => closeModal()}>
            <Icon name="backward" />
            {t("messages:cancel")}
          </Button>
          <Button color="red" onClick={() => confirmDelete()}>
            <Icon name="trash" />
            {t("messages:delete")}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
ModalDeletePage.propTypes = {
  closeModal: PropTypes.func.isRequired,
  confirmDelete: PropTypes.func.isRequired,
  deleteConfirmation: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};
export default withTranslation()(ModalDeletePage);
